import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Header from './Header';
import {
  BREAKPOINT_DESKTOP,
  NAV_HEIGHT_DESKTOP as HEADER_HEIGHT_DESKTOP,
  NAV_HEIGHT_MOBILE as HEADER_HEIGHT_MOBILE,
} from './Header/constants';
import { HeaderProps } from './Header/Header';

const WithHeader = styled.div<{ isSticky: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  position: ${(props) => (props.isSticky ? 'relative' : 'static')};
  margin-top: ${(props) => (props.isSticky ? HEADER_HEIGHT_MOBILE : 0)}px;

  @media ${BREAKPOINT_DESKTOP} {
    margin-top: ${(props) => (props.isSticky ? HEADER_HEIGHT_DESKTOP : 0)}px;
  }
`;

const Headered: FunctionComponent<Omit<HeaderProps, 'pageScrollPosition'>> = ({ children, ...props }) => {
  const [pageScrollPosition, setPageScrollPosition] = useState(0);
  const isMenuOpen = useRef(props.isMenuOpen);
  isMenuOpen.current = props.isMenuOpen;

  useEffect(() => {
    if (!props.isSticky) {
      return;
    }

    const listener = () => {
      const doc = document.documentElement;
      const yPos = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
      if (!isMenuOpen.current) {
        setPageScrollPosition(Math.max(yPos, 0));
      }
    };

    document.addEventListener('scroll', listener);

    return () => document.removeEventListener('scroll', listener);
  }, [props.isSticky]);

  return (
    <>
      <Header {...props} pageScrollPosition={pageScrollPosition} />
      <WithHeader isSticky={props.isSticky}>{children}</WithHeader>
    </>
  );
};

export default Headered;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Headered.tsx